// import { useState } from 'react';
import { Card, GoldBtn, SectionLabel } from '@/components/ui';
import { reservePerks } from '@/content/reservePerks';
import { useIsMobile } from '@/hooks/isMobile';
import { assets, C, externalLinks } from '@/theme/tokens';


/**
 * "Become a Founding Backer" — the primary conversion section.
 *
 * The form is intentionally non-functional for now; the email "Notify Me"
 * action just toggles a confirmation panel. Backend wiring (BackerKit
 * deposit flow, mailing-list capture) will be added in a later phase.
 */
export function ReserveSection() {
  // const [email, setEmail] = useState('');
  // const [emailSubmitted, setEmailSubmitted] = useState(false);
  const isMobile = useIsMobile();

  return (

    <section
      id="reserve"
      style={{
        background: `radial-gradient(ellipse at 50% 0%, #1a3550 0%, #0a1a2a 70%)`,
        padding: '36px 24px',
      }}
    >
      <div style={{ maxWidth: 680, margin: '0 auto', textAlign: 'center' }}>
        <SectionLabel>Secure Your Place</SectionLabel>

        <h2
          style={{
            fontFamily: "'Cinzel',serif",
            fontSize: 'clamp(1.8rem,5vw,2.8rem)',
            fontWeight: 900,
            letterSpacing: '2px',
            color: '#fff',
            textTransform: 'uppercase',
            marginBottom: 16,
            lineHeight: 1.15,
          }}
        >
          Become a <span style={{ color: C.gold }}>Founding Backer.</span>
        </h2>

        {/* Founders urgency badge */}
        <div
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: 8,
            background: 'rgba(212,175,55,0.1)',
            border: '1px solid rgba(212,175,55,0.3)',
            borderRadius: 30,
            padding: '6px 18px',
            marginBottom: 24,
          }}
        >
          <div
            aria-hidden="true"
            style={{
              width: 7,
              height: 7,
              borderRadius: '50%',
              background: '#4E9E51',
              boxShadow: '0 0 8px rgba(78,158,81,0.8)',
              animation: 'pulse-glow 1.5s infinite',
            }}
          />
          <span
            style={{
              fontSize: 12,
              letterSpacing: '1.5px',
              color: C.gold,
              fontFamily: "'Cinzel',serif",
            }}
          >
            FOUNDING BACKER RESERVATIONS AVAILABLE NOW
          </span>
        </div>

        <p
          style={{
            fontSize: 16,
            color: 'rgba(255,255,255,0.65)',
            lineHeight: 1.7,
            maxWidth: 540,
            margin: '0 auto 40px',
          }}
        >
          Put down your $5.00 reservation and join the first wave of adventurers. You'll receive
          exclusive Founding Backer perks, guaranteed early campaign access, and a badge no one else
          can earn after launch day.
        </p>

        {/* Primary CTA Card */}
        <Card glow style={{ padding: '40px 40px', marginBottom: 24, textAlign: 'left' }}>
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'flex-start',
              flexWrap: 'wrap',
              gap: 16,
              marginBottom: 28,
            }}
          >
            <div
              style={{
                display: 'flex',
                alignItems: isMobile ? 'flex-end' : 'flex-start',
                justifyContent: isMobile ? 'space-between' : 'flex-start',
                gap: 16,
                flexDirection: isMobile ? 'row' : 'column',
                width: isMobile ? '100%' : 'auto',
              }}
            >
              <div>
                <div
                  style={{
                    fontFamily: "'Cinzel',serif",
                    fontSize: 13,
                    color: C.bronze,
                    letterSpacing: '2px',
                    textTransform: 'uppercase',
                    marginBottom: 6,
                    whiteSpace: 'nowrap',
                  }}
                >
                  Founding Backer Deposit
                </div>

                <div
                  style={{
                    fontFamily: "'Cinzel',serif",
                    fontSize: 36,
                    fontWeight: 900,
                    color: C.gold,
                    paddingBottom: 8,
                  }}
                >
                  5.00
                </div>
                <div style={{ fontSize: 12, color: C.muted, marginTop: 4 }}>
                  Non-refundable · Exclusive perks · Early access
                </div>
              </div>

              {/* Enamel pin — pre-tilted artwork, no CSS rotation needed */}
              <img
                src={assets.pin}
                alt="Founder QuestXR enamel pin"
                style={{
                  width: isMobile ? 140 : 180,
                  display: isMobile? 'none' : 'inline',
                  height: 'auto',
                  objectFit: 'contain',
                  marginTop: isMobile ? 0 : 12,
                  marginLeft: isMobile ? 100 : 12,
                  flexShrink: 0,
                }}
              />
            </div>

            <div>
              {reservePerks.map((p) => (
                <div
                  key={p}
                  style={{
                    display: 'flex',
                    gap: 8,
                    alignItems: 'center',
                    marginBottom: 8,
                  }}
                >
                  <span style={{ color: C.gold, fontSize: 10 }}>◆</span>
                  <span
                    style={{ fontSize: 13, color: 'rgba(255,255,255,0.7)', fontWeight: 300 }}
                    dangerouslySetInnerHTML={{ __html: p }}
                  />
                </div>
              ))}
            </div>
            <img
              src={assets.pin}
              alt="Founder QuestXR enamel pin"
              style={{
                width: 200,
                display: isMobile ? 'block' : 'none',
                height: 'auto',
                objectFit: 'contain',
                flexShrink: 0,
                margin: '6px auto'   // 12px top/bottom, auto left/right = centered
              }}
            />
          </div>

          <GoldBtn size="lg" href={externalLinks.backerKit} style={{ width: '100%', fontSize: 16, padding: '16px 32px' }}>
            ✦ Reserve your spot now ✦
          </GoldBtn>
          {/*<p style={{ textAlign: 'center', fontSize: 11, color: C.dim, marginTop: 10 }}>
            Payment processing via BackerKit · Secure checkout
          </p>*/}
        </Card>

        {/* Email fallback 
        <div
          style={{
            padding: '28px',
            background: 'rgba(20,38,59,0.7)',
            border: '1px solid rgba(193,154,107,0.3)',
            borderRadius: 5,
          }}
        >
          {emailSubmitted ? (
            <div style={{ textAlign: 'center' }}>
              <div style={{ fontSize: 28, marginBottom: 8 }}>✦</div>
              <p
                style={{
                  fontFamily: "'Cinzel',serif",
                  fontSize: 15,
                  color: C.gold,
                  letterSpacing: '1px',
                }}
              >
                You're on the list, Adventurer.
              </p>
              <p style={{ fontSize: 13, color: C.muted, marginTop: 6 }}>
                We'll send you a direct link the moment the campaign goes live.
              </p>
            </div>
          ) : (
            <>
              <p
                style={{
                  fontFamily: "'Cinzel',serif",
                  fontSize: 13,
                  color: '#fff',
                  letterSpacing: '1px',
                  textTransform: 'uppercase',
                  marginBottom: 6,
                }}
              >
                Not ready to commit? Get notified at launch.
              </p>
              <p style={{ fontSize: 13, color: C.muted, marginBottom: 16 }}>
                Sign up for a free reminder when the campaign goes live — no payment needed.
              </p>
              <form
                style={{ display: 'flex', gap: 10, flexWrap: 'wrap' }}
                onSubmit={(e) => {
                  e.preventDefault();
                  if (email) setEmailSubmitted(true);
                }}
              >
                <label htmlFor="reserve-email" style={{ position: 'absolute', left: -9999 }}>
                  Email address
                </label>
                <input
                  id="reserve-email"
                  type="email"
                  placeholder="your@email.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  style={{
                    flex: 1,
                    minWidth: 200,
                    padding: '10px 16px',
                    background: 'rgba(10,26,42,0.8)',
                    border: `1px solid ${C.bronze}`,
                    borderRadius: 30,
                    color: '#fff',
                    fontSize: 14,
                    fontFamily: "'Roboto',sans-serif",
                    outline: 'none',
                  }}
                  onFocus={(e) => {
                    e.currentTarget.style.borderColor = C.gold;
                  }}
                  onBlur={(e) => {
                    e.currentTarget.style.borderColor = C.bronze;
                  }}
                />
                <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
                  <GoldBtn
                    variant="outlined"
                    onClick={() => {
                      if (email) setEmailSubmitted(true);
                    }}
                  >
                    Notify Me
                  </GoldBtn>
                </div>
              </form>
            </>
          )}
        </div>*/}
      </div>
    </section>
  );
}
